import React from "react";
import { Card } from "../core/Card";

export function StepCard({ index, title, body, inverse = false }) {
  return (
    <Card variant={inverse ? "inverse" : "default"} padding="lg">
      <span style={{
        fontFamily: "var(--font-mono)", fontSize: "var(--text-sm)",
        color: inverse ? "var(--hive)" : "var(--text-accent)",
      }}>{String(index).padStart(2, "0")}</span>
      <h3 style={{
        marginTop: "var(--space-2)", fontFamily: "var(--font-display)",
        fontWeight: "var(--weight-bold)", fontSize: "var(--text-card-title)",
        letterSpacing: "var(--tracking-tight)",
        color: inverse ? "var(--text-inverse)" : "var(--text-body)",
      }}>{title}</h3>
      <p style={{
        marginTop: "var(--space-2)", fontSize: "var(--text-base)",
        lineHeight: "var(--leading-relaxed)", maxWidth: "var(--measure-body)",
        color: inverse ? "var(--cream-a80)" : "var(--text-muted)",
      }}>{body}</p>
    </Card>
  );
}
